module.exports = __webpack_public_path__ + "static/media/RPFPC_Youth_Football_Grant_Application_2018.50d6296b.pdf";